import TextField from "../../../components/fields/textField/TextField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import ConfirmDialog from "../../../components/dialog/confirm/ConfirmDialog.vue"
import moment from "moment";
import { SnackBarModule } from "../../../modules/SnackBarModule";
import { SolicitarFeriasService } from "../../../services/SolicitarFeriasService";
import { FeriasService } from "../../../services/FeriasService";
import { date, strtotime } from "date-typescript-library";
import { tipoPerfil,TiposFeriasEnum } from "../../../constants";

export default {
  name: "SolicitarFerias30Anos",

  components: {
    TextField,
    PeriodoField,
    SelectField,
    ConfirmDialog
  },
  props:{
    selected:{
      default:""
    }
  },
  
  data: () => ({
    form: {},
    campos: 0,
    confirmDialog: false,

    diasRestantes: 0,
    saldoFerias: 0,
    
    role: "",

    exerciciosOptions: [],
    responsavelOptions:[],

    responsavel:[],
    loading: {
      field: false,
      btn: false
    }
  }),

  beforeMount() {
    this.role = this.$store.state.user.Perfis.indexOf(tipoPerfil['COMANDANTE']) != -1;
    this.initializeForm();
    this.pegarDiasRestantesDaParecela();
  },

  mounted() {
    this.getExercicioItems();
    this.getResponsavelItems();

  },

  methods: {
    async pegarDiasRestantesDaParecela(index,event) {
      this.form[index].subtitulo = "Por favor selecione um exercício";

      event != undefined ? this.form[index].exercicio = event : ""
      const formData = new FormData();

      formData.append('exercicio', this.form[index].exercicio);
      formData.append('id_tipo',TiposFeriasEnum.FERIAS_30_ANOS );

      const response = await SolicitarFeriasService.pegarDiasRestantes(formData);
      if(response.exercicio != null){
        this.form[index].subtitulo = `Você possui um saldo de ${response.dias} dia(s) no exercício ${response.exercicio}`
      }

      this.saldoFerias = response.dias;

        //Update no forms inteiro para pode atualizar os valores
        this.form[this.campos] = {}
        this.form.pop()
    },

    async getExercicioItems() {
      this.loading.field = true;
      const postData = new FormData();
      postData.append('id_tipo', TiposFeriasEnum.FERIAS_30_ANOS)
      const response = await FeriasService.getExercicio(postData);
      this.exerciciosOptions = response.map(el => {
        return {
          text: el.ano,
          value: el.ano,
        }
      });
      this.exerciciosOptions?.unshift({ text: "Selecione", value: "" })
      this.loading.field = false;
    },
    async getResponsavelItems() {
      this.loading.field = true;
      const response = await FeriasService.getMilitaresResponsavel();
      this.responsavelOptions = response.map(el => {
        return {
          text: el.nome,
          value: el.id,
        }
      });
      this.responsavelOptions?.unshift({ text: "Selecione", value: "" })
      this.loading.field = false;
    },

    async calculateDays(index) {
  
      if (this.form[index].dataInicio) {
        const formData = new FormData();
        formData.append("data_ini", moment(this.form[index].dataInicio).format("YYYY-MM-DD"));
        formData.append("dias",this.form[index].numeroDias);
        const response =  await SolicitarFeriasService.calcularDiasUteis(formData);
        this.form[index].dataFim = response.dataFim;
        this.form[index].numeroDias = response.dias_uteis;
        const doisMeses = date("Y-m-d",strtotime("+ 2 MONTHS"));
        this.confirmDialog = doisMeses > moment(this.form[index].dataInicio).format("YYYY-MM-DD")
        
        //Update no forms inteiro para pode atualizar os valores
        this.form[this.campos] = {}
        this.form.pop()

        return this.calcularTotalDiasRestantes();
      }
      return SnackBarModule("Prencha o campo de data inicial", "error");
    },

    calcularTotalDiasRestantes(){
      this.diasRestantes = 25;
      this.form.forEach( (value) =>{
          this.diasRestantes = this.diasRestantes - parseInt(value.numeroDias)
          if(this.diasRestantes < 0){
            return SnackBarModule("Número de dias dos períodos solicitados juntos devem ser menor que 25", "error");

          }
      })
      return;
    },

    verificarSeTodasDatasIniciasSaoMenoresQueUltimaDataFinal(){
      if(this.campos > 1){
       this.form.forEach((value)=>{
        if(this.form[this.campos-1].dataInicio < value.dataFim){
          return SnackBarModule("A data início deverá ser maior que a data final da última parcela", "error");
        }
       })
      }
      return;
    },

    prepareForm() {
      const formData = new FormData();
      let form = true;
      this.form.forEach( (element, index) => {
        
        if(element.dataInicio == null || element.dataFim == null || element.exercicio == "" || element.numeroDias == ""){
          form = false
          SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
          
        }  

        if( element.numeroDias > this.saldoFerias){
          form = false
          SnackBarModule("Saldo insuficiente", "error");

        }

        if( element.numeroDias == 0){
          form = false
          SnackBarModule("O número de dias deve ser maior que zero", "error");
        }
         
        formData.append(`ferias[${index}][data_ini]`, moment(element.dataInicio).format("YYYY-MM-DD"))
        formData.append(`ferias[${index}][data_fin]`, moment(element.dataFim).format("YYYY-MM-DD"))
        formData.append(`ferias[${index}][exercicio]`, element.exercicio)
        formData.append(`ferias[${index}][id_tipo]`,1)
        formData.append(`ferias[${index}][dias]`,element.numeroDias)

       
      });
      formData.append(`id_responsavel_ferias`,this.responsavel)

      if(form){
        this.sendForm(formData);
        return;
      }

    },

    createNewForm(){
      this.campos = this.campos + 1
      this.form[this.campos-1] = {  
        subtitulo: "Por favor selecione uma parcela", 
        exercicio: "",
        dataInicio: null,
        dataFim: null,
        numeroDias: ""
      }
    },

    
    removePeriodoFerias(){
      this.diasLimite = this.diasLimite + parseInt(this.form[this.campos-1].numeroDias )
      this.form.pop()
      this.campos = this.campos -1
      
    },

    async sendForm(formData) {
      this.loading.btn = true;
      const response = await SolicitarFeriasService.postFeriasPremio30Anos(formData);
      this.loading.btn = false;
      if (response) {
        this.initializeForm();
        this.$emit('on-confirm');
        this.close();
      }
      this.loading.btn = false;
    },

    initializeForm() {
      this.campos = 1
      this.form = [
        {   
        subtitulo: "Por favor selecione uma parcela",
        exercicio: "",
        dataInicio: null,
        dataFim: null,
        numeroDias: ""
      }
      ]
    },

    close() {
      this.$emit("on-close");
    },
  }
};